module.exports = __webpack_public_path__ + "static/media/topview_lowSize.20bfb738.png";